import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import FeedbackForm from './FeedbackForm';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/feedback" element={<FeedbackForm />} />
    </Routes>
  );
};

export default App;